"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.z = exports.removeMarshaller = exports.addMarshaller = exports.isNullish = void 0;
const zod_1 = require("zod");
Object.defineProperty(exports, "z", { enumerable: true, get: function () { return zod_1.z; } });
const ZodBooleanMarshaller_1 = require("./ZodBooleanMarshaller");
const ZodDateTimeMarshaller_1 = require("./ZodDateTimeMarshaller");
const ZodFloatMarshaller_1 = require("./ZodFloatMarshaller");
const ZodIntegerMarshaller_1 = require("./ZodIntegerMarshaller");
const ZodRecipientMarshaller_1 = require("./ZodRecipientMarshaller");
/**
 * Returns true if the value tested is exactly equal to null or undefined.
 * @param value value to test
 * @returns boolean
 */
function isNullish(value) {
    return typeof value === 'undefined' || value === null;
}
exports.isNullish = isNullish;
/* eslint-enable @typescript-eslint/no-explicit-any */
const marshallers = new Map([
    ['float', (v, options) => ZodFloatMarshaller_1.FloatMarshaller(v, { ...options, nullable: false })],
    ['float?', (v, options) => ZodFloatMarshaller_1.FloatMarshaller(v, { ...options, nullable: true })],
    ['integer', (v, options) => ZodIntegerMarshaller_1.IntegerMarshaller(v, { ...options, nullable: false })],
    ['integer?', (v, options) => ZodIntegerMarshaller_1.IntegerMarshaller(v, { ...options, nullable: true })],
    ['boolean', (v, options) => ZodBooleanMarshaller_1.BooleanMarshaller(v, { ...options, nullable: false })],
    ['boolean?', (v, options) => ZodBooleanMarshaller_1.BooleanMarshaller(v, { ...options, nullable: true })],
    ['recipient', ZodRecipientMarshaller_1.RecipientMarshaller],
    ['datetime', (v, options) => ZodDateTimeMarshaller_1.DateTimeMarshaller(v, { ...options, nullable: false })],
    ['datetime?', (v, options) => ZodDateTimeMarshaller_1.DateTimeMarshaller(v, { ...options, nullable: true })],
]);
/* eslint-disable @typescript-eslint/no-explicit-any */
zod_1.z.ZodType.prototype.marshalTo = function (type, options) {
    /* eslint-enable @typescript-eslint/no-explicit-any */
    const delegate = marshallers.get(String(type));
    if (!delegate) {
        throw new Error(`no marshaller available for type ${type}`);
    }
    return delegate(this, options);
};
/* eslint-disable @typescript-eslint/no-explicit-any */
zod_1.z.ZodType.prototype.marshalToCustom = function (type, options) {
    /* eslint-enable @typescript-eslint/no-explicit-any */
    const delegate = marshallers.get(type);
    if (!delegate) {
        throw new Error(`no marshaller available for type ${type}`);
    }
    return delegate(this, options);
};
/**
 * Registers a custom marshaller.
 *
 * @param name name of the marshaller
 * @param marshaller marshaller implementation
 * @throws when a marshaller is already registered with the same name
 */
function addMarshaller(name, marshaller) {
    if (marshallers.has(name)) {
        throw new Error(`a marshaller for "${name}" is already registered`);
    }
    marshallers.set(name, marshaller);
}
exports.addMarshaller = addMarshaller;
/**
 * Removes a registered marshaller. Instead of using this method, you should be
 * ensuring that there are no naming collisions of the registered marshallers.
 *
 * @deprecated
 * @param name name of the marshaller to remove
 * @returns true if a marshaller was actually removed
 */
function removeMarshaller(name) {
    return marshallers.delete(name);
}
exports.removeMarshaller = removeMarshaller;
//# sourceMappingURL=ZodExtensions.js.map